<template>
    <div>硬件配置</div>
</template>

<script setup>

</script>

<style scoped>

</style>
